// src/utils/themeLoader.js
export function applyThemeCSS(theme) {
    console.log('applyThemeCSS', theme);
    const id = 'theme-css';
    let existing = document.getElementById(id);
    if (existing) existing.remove();

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.id = id;
    if (theme === 'dark') {
        link.href = '/css/theme_dark.css';
        document.head.appendChild(link);
   }
}

export function getInitialTheme() {
  const saved = localStorage.getItem('MEW_CURRENT_THEME_THEORY');
  return JSON.parse(saved);
}

export function applyThemeClass(theme) {
  document.documentElement.classList.remove('mew--theme--dark','mew--theme--light','theme--light');
  if (theme === 'dark') {
    document.body.classList.add('mew--theme--dark');
  }
}